import User from '../../../../models/User';
import useCustomers from '../../../../hooks/useCustomers';

const Company: React.FC<{ user: User }> = ({ user }) => {
    const { data: customers } = useCustomers();
    return <>{customers?.find((cust) => cust.id === user.customerId)?.name ?? '-'}</>;
};

export default Company;
